import styled from 'styled-components'
import GroupFilterTag from './GroupFilterTag.jsx'

const TagsWrap = styled.div`
  display: inline-flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 640px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`

/**
 * GroupFilterTagsContainer
 * Props:
 * - tags: Array<{ id: string, label: string, selectorIndex: number }>
 * - onRemove(tagId: string): void
 *
 * Renders each tag in selection order; on mobile they scroll sideways. With
 * no tags the list shows everything, so the caller renders nothing at all.
 */
const GroupFilterTagsContainer = ({ tags = [], onRemove }) => {
  const handleRemove = (id) => onRemove?.(id)

  return (
    <TagsWrap data-testid="groupfilter.tags.wrap">
      {tags.map(t => (
        <GroupFilterTag key={`${t.selectorIndex}:${t.id}`} label={t.label} onRemove={() => handleRemove(t.id)} />
      ))}
    </TagsWrap>
  )
}

export default GroupFilterTagsContainer
